import { Model } from 'json-api-models';

import { Models, Schemas } from '../models.ts';

export class TagResult extends Model<Schemas['tagResults'], Models> {}
